// extracted by mini-css-extract-plugin
module.exports = {"loginButton":"Header_loginButton__1DXpK","cursor":"Header_cursor__1hpzE","userPhoto":"Header_userPhoto__1304p","userlink":"Header_userlink__1-xR9"};